import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066d892d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper-admin-dashboard"
}
const _hoisted_2 = { class: "app-version" }
const _hoisted_3 = {
  key: 0,
  class: "container-user-overview"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Display name"),
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Creation date"),
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Last seen"),
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Walthrough"),
    /*#__PURE__*/_createElementVNode("th", { class: "footnote" }, "Role")
  ])
], -1))
const _hoisted_5 = { class: "sticky-col" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "container-dropdowns" }
const _hoisted_9 = { class: "loader-container" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!

  return (_ctx.isAdmin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_PageHeader, { "header-text": "Admin Dashboard" }),
        _createElementVNode("div", _hoisted_2, "Version " + _toDisplayString(_ctx.appVersion), 1),
        (_ctx.allUsers.length > 0 && !_ctx.loader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", null, [
                _hoisted_4,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allUsers, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user._id
                    }, [
                      _createElementVNode("td", _hoisted_5, _toDisplayString(user.displayName), 1),
                      _createElementVNode("td", null, _toDisplayString(user.email), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.convertStringToFormattedDate(user.creationDate)), 1),
                      (user.lastSeenDate)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.convertStringToFormattedDate(user.lastSeenDate)), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_7, "-")),
                      _createElementVNode("td", null, [
                        (user.walkthroughComplete)
                          ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                              key: 0,
                              style: {"color":"lightgreen"}
                            }))
                          : (_openBlock(), _createBlock(_component_XCircleIcon, {
                              key: 1,
                              style: {"color":"red"}
                            }))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(user.role), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_component_DropDown, {
              "header-text": "Run scripts",
              key: 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "drop-down-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportRecipes && _ctx.exportRecipes(...args)))
                }, " Export recipes ")
              ]),
              _: 1
            }))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.loader)
            ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.successMessages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successMessages, (message) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "success",
                  key: message
                }, _toDisplayString(message), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1)
      ]))
    : _createCommentVNode("", true)
}